import 'bootstrap/dist/css/bootstrap.min.css';
import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from './components/UI'
import directives from './directives'
import getUtm from "./mixins/getUtm"
import 'bootstrap';
import {createHead} from "@unhead/vue/client";

window.bootstrap = require('bootstrap')

const app = createApp(App)
const head = createHead()

components.forEach(component => {
    app.component(component.name, component)
})

directives.forEach(directive => {
    app.directive(directive.name, directive)
})

app.use(head)
app.use(store)
app.use(router)
app.mount('#app')

app.mixin(getUtm)

// Глобальные мета-теги
head.push({
    title: 'p-l-e.ru — Поиск недвижимости | Квартиры, ЖК, застройщики, коммерческая недвижимость',
    meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
        { name: 'description', content: 'Актуальные объявления о продаже недвижимости. Жилые комплексы, застройщики, коммерческая недвижимость и аналитические статьи.' },
        { name: 'keywords', content: 'недвижимость, купить квартиру, ЖК, застройщики, коммерческая недвижимость, объявления' },

        // OpenGraph (для соцсетей)
        { property: 'og:title', content: 'p-l-e.ru — Поиск недвижимости | Квартиры, ЖК, застройщики, коммерческая недвижимость' },
        { property: 'og:description', content: 'Все объявления о недвижимости в одном месте: новостройки, вторичка, коммерция.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://p-l-e.ru' },
        { property: 'og:image', content: 'https://p-l-e.ru/logo-textless.png' },
        { property: 'og:site_name', content: 'p-l-e.ru' },

        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'p-l-e.ru — Поиск недвижимости' },
        { name: 'twitter:description', content: 'Актуальные объявления о недвижимости' },
        { name: 'twitter:image', content: 'https://p-l-e.ru/logo-textless.png' }
    ],
    link: [
        { rel: 'icon', href: '/favicon.ico' },
        { rel: 'canonical', href: 'https://p-l-e.ru' }
    ]
})